import styled from "@emotion/styled";
import customerCurvesLeft from "../../../images/customer_left_curves.svg";
import customerCurvesRight from "../../../images/customer_right_curves.svg";
import media from "../../breakpoints";

const WhySectionWrapper = styled.section`
  overflow: hidden;
  .card-size {
    ${media("md")} {
      max-width: 328px !important;
    }
  }
  .wrapper-parent {
    min-height: 600px;
  }
  .image-parent {
    .gatsby-image-wrapper {
      max-width: 1249px;
    }
  }

  .title-parent {
    max-width: 585px;
    font-weight: 600;
    font-size: 34px;
    line-height: 44px;
    ${media("md")} {
      font-size: 28px;
      line-height: 38px;
    }
  }
  .btn-parent {
    max-width: 177px;
    ${media("md")} {
      max-width: 24rem;
    }
  }
  .accordion-parent {
    max-width: 375px;
  }
  .curves-parent-left {
    background: url(${customerCurvesLeft}) center no-repeat;
    width: 1624px;
    height: 542px;
    transform: translate(-26%, 50%);
  }
  .curves-parent-right {
    background: url(${customerCurvesRight}) center no-repeat;
    width: 1624px;
    height: 542px;
    transform: translate(-70%, 15%);
    ${media("md")} {
      transform: translate(-60%, 15%);
    }
  }
`;

export { WhySectionWrapper };
